// extracted by mini-css-extract-plugin
export default {"root":"SelectFromCloudPopup__root--7EUT-"};